const MAX_SCALE = 8;
const CURSOR_MIN_WIDTH = 13;
const CURSOR_MAX_WIDTH = 43;

export { CURSOR_MAX_WIDTH, CURSOR_MIN_WIDTH, MAX_SCALE };
//# sourceMappingURL=scrubbable.constants.js.map
